"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HourlyUsageAttributes = void 0;
/**
 * Attributes of hourly usage for a product family for an org for a time period.
 */
class HourlyUsageAttributes {
    constructor() { }
    /**
     * @ignore
     */
    static getAttributeTypeMap() {
        return HourlyUsageAttributes.attributeTypeMap;
    }
}
exports.HourlyUsageAttributes = HourlyUsageAttributes;
/**
 * @ignore
 */
HourlyUsageAttributes.attributeTypeMap = {
    measurements: {
        baseName: "measurements",
        type: "Array<HourlyUsageMeasurement>",
    },
    orgName: {
        baseName: "org_name",
        type: "string",
    },
    productFamily: {
        baseName: "product_family",
        type: "string",
    },
    publicId: {
        baseName: "public_id",
        type: "string",
    },
    region: {
        baseName: "region",
        type: "string",
    },
    timestamp: {
        baseName: "timestamp",
        type: "Date",
        format: "date-time",
    },
};
//# sourceMappingURL=HourlyUsageAttributes.js.map